import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import { countryNamesDe, countryNamesEn } from './i18n-iso-countries'
/* eslint-disable no-restricted-imports
   -------
   There is a type inference bug if we import
   it through module/[moduleName]/index.ts file.
   It has to be imported directly from the json file.
*/
import deAbsences from './modules/absences/translations/de.json'
import enAbsences from './modules/absences/translations/en.json'
import deAbsences2 from './modules/absences2/translations/de.json'
import enAbsences2 from './modules/absences2/translations/en.json'
import deAuth from './modules/auth/translations/de.json'
import enAuth from './modules/auth/translations/en.json'
import deAvailabilityManagement from './modules/availabilityManagement/translations/de.json'
import enAvailabilityManagement from './modules/availabilityManagement/translations/en.json'
import deClasses from './modules/classes/translations/de.json'
import enClasses from './modules/classes/translations/en.json'
import deCourses from './modules/courses/translations/de.json'
import enCourses from './modules/courses/translations/en.json'
import deCoursesManagement from './modules/coursesManagement/translations/de.json'
import enCoursesManagement from './modules/coursesManagement/translations/en.json'
import deCoveredCancelledLessons from './modules/coveredAndCancelledLessons/translations/de.json'
import enCoveredCancelledLessons from './modules/coveredAndCancelledLessons/translations/en.json'
import deCurriculumsManagement from './modules/curriculumsManagement/translations/de.json'
import enCurriculumsManagement from './modules/curriculumsManagement/translations/en.json'
import deLessonDetails from './modules/lessonDetails/translations/de.json'
import enLessonDetails from './modules/lessonDetails/translations/en.json'
import deRooms from './modules/rooms/translations/de.json'
import enRooms from './modules/rooms/translations/en.json'
import deSchoolSettings from './modules/schoolSettings/translations/de.json'
import enSchoolSettings from './modules/schoolSettings/translations/en.json'
import deSections from './modules/sections/translations/de.json'
import enSections from './modules/sections/translations/en.json'
import deStudents from './modules/students/translations/de.json'
import enStudents from './modules/students/translations/en.json'
import deTimetable from './modules/timetable/translations/de.json'
import enTimetable from './modules/timetable/translations/en.json'
import deUsers from './modules/users/translations/de.json'
import enUsers from './modules/users/translations/en.json'
/* eslint-enable no-restricted-imports */
import deCommon from './translations/de.json'
import enCommon from './translations/en.json'

export const resources = {
  en: {
    common: enCommon,
    auth: enAuth,
    timetable: enTimetable,
    lessonDetails: enLessonDetails,
    students: enStudents,
    classes: enClasses,
    courses: enCourses,
    coursesManagement: enCoursesManagement,
    rooms: enRooms,
    users: enUsers,
    absences: enAbsences,
    absences2: enAbsences2,
    coveredCancelledLessons: enCoveredCancelledLessons,
    availabilityManagement: enAvailabilityManagement,
    countries: { names: countryNamesEn },
    curriculumsManagement: enCurriculumsManagement,
    schoolSettings: enSchoolSettings,
    sections: enSections
  },
  de: {
    common: deCommon,
    auth: deAuth,
    timetable: deTimetable,
    courses: deCourses,
    coursesManagement: deCoursesManagement,
    rooms: deRooms,
    lessonDetails: deLessonDetails,
    students: deStudents,
    classes: deClasses,
    users: deUsers,
    absences: deAbsences,
    absences2: deAbsences2,
    coveredCancelledLessons: deCoveredCancelledLessons,
    availabilityManagement: deAvailabilityManagement,
    countries: { names: countryNamesDe },
    curriculumsManagement: deCurriculumsManagement,
    schoolSettings: deSchoolSettings,
    sections: deSections
  }
} as const

i18n.use(initReactI18next).init({
  preload: ['en'],
  resources,
  lng:
    localStorage.getItem('language') || import.meta.env.VITE_DEFAULT_LANGUAGE,
  fallbackLng: 'en',

  interpolation: {
    escapeValue: false
  }
})

export default i18n
